import { render } from "./Ledger_Details.vue?vue&type=template&id=6865579a&scoped=true"
import script from "./Ledger_Details.vue?vue&type=script&lang=js"
export * from "./Ledger_Details.vue?vue&type=script&lang=js"

import "./Ledger_Details.vue?vue&type=style&index=0&id=6865579a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6865579a"]])

export default __exports__